<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>招聘管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/position/detail/'+id}">职位列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :show-header="false">
      <el-form ref="form"
               :model="form"
               :rules="searchRules"
               label-width="120px"
               size="mini">
        <el-row class="text item">
          <el-col :span="24">
            <h2>基本信息</h2>
            <hr>
          </el-col>
          <el-form-item prop="industry_type"
                        label="发布时间:">
            <span>{{form.up_date}}~{{form.down_date}}</span>
          </el-form-item>
          <el-form-item prop="industry_type"
                        label="行业大类:">
            <span v-for="industryType in options.industry_type"
                  v-if="industryType.id === form.industry_type">
              {{industryType.keyword}}
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('industry_type')"></i>
          </el-form-item>
          <el-select clearable
                     v-model="errorFields.industry_type"
                     placeholder="请选择"
                     v-if="dialogVisible.industry_type"
                     @change="onSelectErrorMessage('industry_type')"
                     @clear="onClearErrorMessage('industry_type')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.industry_type"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.industry_type === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.industry_type"
                     @click="removeErrorMessage('industry_type')"></el-button>
          <el-form-item prop="position_type"
                        label="职位类型:">
            <span v-for="positionType in options.position_type"
                  v-if="positionType.id === form.position_type">
              {{positionType.keyword}}
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('position_type')"></i>
          </el-form-item>
          <el-select clearable
                     @clear="onClearErrorMessage('position_type')"
                     v-model="errorFields.position_type"
                     placeholder="请选择"
                     v-if="dialogVisible.position_type"
                     @change="onSelectErrorMessage('position_type')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.position_type"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.position_type === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     @click="removeErrorMessage('position_type')"
                     v-if="dialogVisible.position_type"></el-button>
          <el-form-item prop="title"
                        label="岗位名称:">{{form.title}} &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('title')"></i>
          </el-form-item>
          <el-select clearable
                     @clear="onClearErrorMessage('title')"
                     v-model="errorFields.title"
                     placeholder="请选择"
                     v-if="dialogVisible.title"
                     @change="onSelectErrorMessage('title')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.title"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.title === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.title"
                     @click="removeErrorMessage('title')"></el-button>
          <el-form-item prop="hire_number"
                        label="招聘人数:">{{form.hire_number}} &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('hire_number')"></i>
          </el-form-item>
          <el-select clearable
                     @clear="onClearErrorMessage('hire_number')"
                     v-model="errorFields.hire_number"
                     placeholder="请选择"
                     v-if="dialogVisible.hire_number"
                     @change="onSelectErrorMessage('hire_number')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.hire_number"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.hire_number === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.hire_number"
                     @click="removeErrorMessage('hire_number')"></el-button>
          <el-form-item prop="address"
                        label="工作地点:">{{form.province_name}}-{{form.city_name}}-{{form.area_name}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {{form.address}} &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('address')"></i>
          </el-form-item>
          <el-select clearable
                     @clear="onClearErrorMessage('address')"
                     v-model="errorFields.address"
                     placeholder="请选择"
                     v-if="dialogVisible.address"
                     @change="onSelectErrorMessage('address')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.address"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.address === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.address"
                     @click="removeErrorMessage('address')"></el-button>
          <el-form-item prop="employer_name"
                        label="发布单位:">{{form.employer_name}} &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('employer_name')"></i>
          </el-form-item>
          <el-select clearable
                     @clear="onClearErrorMessage('employer_name')"
                     v-model="errorFields.employer_name"
                     placeholder="请选择"
                     v-if="dialogVisible.employer_name"
                     @change="onSelectErrorMessage('employer_name')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.employer_name"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.employer_name === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.employer_name"
                     @click="removeErrorMessage('employer_name')"></el-button>
        </el-row>
        <br>
        <el-row class="text item">
          <el-col :span="24">
            <h2>职位描述</h2>
            <hr>
          </el-col>
          <el-form-item prop="position_period"
                        label="工作时间:">{{form.position_period}} &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('position_period')"></i>
          </el-form-item>
          <el-select clearable
                     @clear="onClearErrorMessage('position_period')"
                     v-model="errorFields.position_period"
                     placeholder="请选择"
                     v-if="dialogVisible.position_period"
                     @change="onSelectErrorMessage('position_period')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.position_period"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.position_period === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.position_period"
                     @click="removeErrorMessage('position_period')"></el-button>
          <el-form-item prop="working_shifts"
                        label="工作班次:">{{form.working_shifts}} &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('working_shifts')"></i>
          </el-form-item>
          <el-select clearable
                     @clear="onClearErrorMessage('working_shifts')"
                     v-model="errorFields.working_shifts"
                     placeholder="请选择"
                     v-if="dialogVisible.working_shifts"
                     @change="onSelectErrorMessage('working_shifts')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.working_shifts"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.working_shifts === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.working_shifts"
                     @click="removeErrorMessage('working_shifts')"></el-button>
          <el-form-item prop="working_hours"
                        label="工作时长:">{{form.working_hours}} &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('working_hours')"></i>
          </el-form-item>
          <el-select clearable
                     @clear="onClearErrorMessage('working_hours')"
                     v-model="errorFields.working_hours"
                     placeholder="请选择"
                     v-if="dialogVisible.working_hours"
                     @change="onSelectErrorMessage('working_hours')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.working_hours"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.working_hours === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.working_hours"
                     @click="removeErrorMessage('working_hours')"></el-button>
          <el-form-item prop="gender"
                        label="性别要求:">
            <span v-for="gender in options.gender"
                  v-if="gender.id === form.gender">
              {{gender.keyword}}
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('gender')"></i>
          </el-form-item>
          <el-select clearable
                     @clear="onClearErrorMessage('gender')"
                     v-model="errorFields.gender"
                     placeholder="请选择"
                     v-if="dialogVisible.gender"
                     @change="onSelectErrorMessage('gender')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.gender"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.gender === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.gender"
                     @click="removeErrorMessage('gender')"></el-button>
          <el-form-item prop="age_range"
                        label="年龄要求:">{{form.age_range}} &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('age_range')"></i>
          </el-form-item>
          <el-select clearable
                     @clear="onClearErrorMessage('age_range')"
                     v-model="errorFields.age_range"
                     placeholder="请选择"
                     v-if="dialogVisible.age_range"
                     @change="onSelectErrorMessage('age_range')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.age_range"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.age_range === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.age_range"
                     @click="removeErrorMessage('age_range')"></el-button>
          <el-form-item prop="certificate"
                        label="证件要求:">{{form.certificate}} &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('certificate')"></i>
          </el-form-item>
          <el-select clearable
                     @clear="onClearErrorMessage('certificate')"
                     v-model="errorFields.certificate"
                     placeholder="请选择"
                     v-if="dialogVisible.certificate"
                     @change="onSelectErrorMessage('certificate')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.certificate"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.certificate === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.certificate"
                     @click="removeErrorMessage('certificate')"></el-button>
          <el-form-item prop="education"
                        label="学历要求:">
            <span v-for="education in options.education"
                  v-if="education.id === form.education">
              {{education.keyword}}
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('education')"></i>
          </el-form-item>
          <el-select clearable
                     @clear="onClearErrorMessage('education')"
                     v-model="errorFields.education"
                     placeholder="请选择"
                     v-if="dialogVisible.education"
                     @change="onSelectErrorMessage('education')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.education"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.education === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.education"
                     @click="removeErrorMessage('education')"></el-button>
          <el-form-item prop="marriage"
                        label="婚姻状况:">
            <span v-for="marriage in options.marriage"
                  v-if="marriage.id === form.marriage">
              {{marriage.keyword}}
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('marriage')"></i>
          </el-form-item>
          <el-select clearable
                     @clear="onClearErrorMessage('marriage')"
                     v-model="errorFields.marriage"
                     placeholder="请选择"
                     v-if="dialogVisible.marriage"
                     @change="onSelectErrorMessage('marriage')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.marriage"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.marriage === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.marriage"
                     @click="removeErrorMessage('marriage')"></el-button>
          <el-form-item prop="working_experience"
                        label="工作经验:">{{form.working_experience}} &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('working_experience')"></i>
          </el-form-item>
          <el-select clearable
                     @clear="onClearErrorMessage('working_experience')"
                     v-model="errorFields.working_experience"
                     placeholder="请选择"
                     v-if="dialogVisible.working_experience"
                     @change="onSelectErrorMessage('working_experience')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.working_experience"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.working_experience === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.working_experience"
                     @click="removeErrorMessage('working_experience')"></el-button>
          <el-form-item prop="other_requirements"
                        label="补充说明:">{{form.other_requirements}} &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('other_requirements')"></i>
          </el-form-item>
          <el-select clearable
                     @clear="onClearErrorMessage('other_requirements')"
                     v-model="errorFields.other_requirements"
                     placeholder="请选择"
                     v-if="dialogVisible.other_requirements"
                     @change="onSelectErrorMessage('other_requirements')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.other_requirements"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.other_requirements === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.other_requirements"
                     @click="removeErrorMessage('other_requirements')"></el-button>
        </el-row>
        <br/>
        <el-row class="text item">
          <el-col :span="24">
            <h2>薪资福利</h2>
            <hr>
          </el-col>
          <el-form-item prop="salary"
                        label="基本薪资:">
            <span v-for="salary in options.salary"
                  v-if="salary.id === form.salary">{{salary.keyword}}</span>
            <span v-for="salaryType in options.salary_type"
                  v-if="salaryType.id === form.salary_type">
              {{salaryType.keyword}}
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('salary')"></i>
          </el-form-item>
          <el-select v-model="errorFields.salary"
                     placeholder="请选择"
                     v-if="dialogVisible.salary"
                     @change="onSelectErrorMessage('salary')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.salary"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.salary === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.salary"
                     @click="removeErrorMessage('salary')"></el-button>
          <el-form-item label="提成机制:">{{form.commission}} &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('commission')"></i>
          </el-form-item>
          <el-select v-model="errorFields.commission"
                     placeholder="请选择"
                     v-if="dialogVisible.commission"
                     @change="onSelectErrorMessage('commission')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.commission"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.commission === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.commission"
                     @click="removeErrorMessage('commission')"></el-button>
          <el-form-item prop="quarterly_bonus"
                        label="季度奖金:">{{form.quarterly_bonus}} &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('quarterly_bonus')"></i>
          </el-form-item>
          <el-select v-model="errorFields.quarterly_bonus"
                     placeholder="请选择"
                     v-if="dialogVisible.quarterly_bonus"
                     @change="onSelectErrorMessage('quarterly_bonus')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.quarterly_bonus"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.quarterly_bonus === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.quarterly_bonus"
                     @click="removeErrorMessage('quarterly_bonus')"></el-button>
          <el-form-item prop="insurance"
                        label="社保缴纳:">
            <span v-for="insurance in options.insurance"
                  v-if="insurance.id === form.insurance">
              {{insurance.keyword}}
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('insurance')"></i>
          </el-form-item>
          <el-select v-model="errorFields.insurance"
                     placeholder="请选择"
                     v-if="dialogVisible.insurance"
                     @change="onSelectErrorMessage('insurance')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.insurance"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.insurance === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.insurance"
                     @click="removeErrorMessage('insurance')"></el-button>
          <el-form-item prop="overtime_pay"
                        label="加班补助:">{{form.overtime_pay}} &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('overtime_pay')"></i>
          </el-form-item>
          <el-select v-model="errorFields.overtime_pay"
                     placeholder="请选择"
                     v-if="dialogVisible.overtime_pay"
                     @change="onSelectErrorMessage('overtime_pay')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.overtime_pay"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.overtime_pay === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.overtime_pay"
                     @click="removeErrorMessage('overtime_pay')"></el-button>
          <el-form-item prop="meal_allowance"
                        label="餐饮补助:">{{form.meal_allowance}} &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('meal_allowance')"></i>
          </el-form-item>
          <el-select v-model="errorFields.meal_allowance"
                     placeholder="请选择"
                     v-if="dialogVisible.meal_allowance"
                     @change="onSelectErrorMessage('meal_allowance')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.meal_allowance"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.meal_allowance === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.meal_allowance"
                     @click="removeErrorMessage('meal_allowance')"></el-button>
          <el-form-item prop="commute_allowance"
                        label="交通补助:">{{form.commute_allowance}} &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('commute_allowance')"></i>
          </el-form-item>
          <el-select v-model="errorFields.commute_allowance"
                     placeholder="请选择"
                     v-if="dialogVisible.commute_allowance"
                     @change="onSelectErrorMessage('commute_allowance')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.commute_allowance"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.commute_allowance === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.commute_allowance"
                     @click="removeErrorMessage('commute_allowance')"></el-button>
          <el-form-item prop="phone_allowance"
                        label="话费补助:">{{form.phone_allowance}} &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('phone_allowance')"></i>
          </el-form-item>
          <el-select v-model="errorFields.phone_allowance"
                     placeholder="请选择"
                     v-if="dialogVisible.phone_allowance"
                     @change="onSelectErrorMessage('phone_allowance')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.phone_allowance"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.phone_allowance === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.phone_allowance"
                     @click="removeErrorMessage('phone_allowance')"></el-button>
          <el-form-item prop="welfare"
                        label="其他福利:">{{form.welfare}} &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('welfare')"></i>
          </el-form-item>
          <el-select v-model="errorFields.welfare"
                     placeholder="请选择"
                     v-if="dialogVisible.welfare"
                     @change="onSelectErrorMessage('welfare')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.welfare"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.welfare === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.welfare"
                     @click="removeErrorMessage('welfare')"></el-button>
          <el-form-item prop="settlement_type"
                        label="结算方式:">
            <span v-for="settlementType in options.settlement_type"
                  v-if="settlementType.id === form.settlement_type">
              {{settlementType.keyword}}
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('settlement_type')"></i>
          </el-form-item>
          <el-select v-model="errorFields.settlement_type"
                     placeholder="请选择"
                     v-if="dialogVisible.settlement_type"
                     @change="onSelectErrorMessage('settlement_type')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.settlement_type"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.settlement_type === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.settlement_type"
                     @click="removeErrorMessage('settlement_type')"></el-button>
          <el-form-item prop="settlement_time"
                        label="结算时间:">
            <span v-for="settlementTime in options.settlement_time"
                  v-if="settlementTime.id === form.settlement_time">
              {{settlementTime.keyword}}
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <i class="el-icon-circle-plus"
               @click="showErrorMessage('settlement_time')"></i>
          </el-form-item>
          <el-select v-model="errorFields.settlement_time"
                     placeholder="请选择"
                     v-if="dialogVisible.settlement_time"
                     @change="onSelectErrorMessage('settlement_time')">
            <el-option v-for="item in options.errorMessage"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
          <el-input v-model="inputErrorFields.settlement_time"
                    placeholder="请输入审核不通过原因"
                    style="width:250px"
                    v-if="errorFields.settlement_time === 5"
                    :maxlength="20"></el-input>
          <el-button type="primary"
                     icon="el-icon-delete"
                     v-if="dialogVisible.settlement_time"
                     @click="removeErrorMessage('settlement_time')"></el-button>
        </el-row>
      </el-form>
      <el-form ref="form"
               :model="checkForm"
               label-width="80px"
               size="mini">
        <el-row class="text item">
          <el-col :span="24">
            <h2>审核信息</h2>
            <hr>
          </el-col>
          <el-col :span="8">
            <el-form-item label="用户id:">{{checkForm.userid}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="用户真名:">{{checkForm.realname}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="用户等级:">
              <span v-for="value in options.level"
                    v-if="value.id === checkForm.level">
                {{value.keyword}}
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="当前状态:">
              <span v-for="value in options.currentstatus"
                    v-if="value.id === checkForm.currentstatus">
                {{value.keyword}}
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所在地:">{{checkForm.current_location.system}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="手机号:">{{checkForm.cellphone}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电子邮箱:">{{form.email}}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="注册时间:">{{checkForm.registertime}}</el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="赏金信息:">可提现金额: {{checkForm.balance}} 冻结金额: {{checkForm.frozenbalance}} 已提现金额:
              {{checkForm.totalwithdraw}}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="零豆信息:">积分总数: {{checkForm.points}}&nbsp;&nbsp;&nbsp;&nbsp; 冻结积分:
              {{checkForm.frozenpoints}} &nbsp;&nbsp;&nbsp;&nbsp;已花费积分: {{checkForm.spendpoints}}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="图片证据:">
              <span v-for="value in form.proof">
                <a :href="value"
                   target="_Blank"
                   v-if="value">
                  <img :src="value+'?x-oss-process=image/resize,w_100/auto-orient,1'"
                       width="100px;"
                       height="100px;"
                       style="border-radius:50px">
                </a>
              </span>
              <i class="el-icon-circle-plus"
                 @click="showErrorMessage('proof')"></i>
            </el-form-item>
            <el-select v-model="errorFields.proof"
                       placeholder="请选择"
                       v-if="dialogVisible.proof"
                       @change="onSelectErrorMessage('proof')">
              <el-option v-for="item in options.errorMessage"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
            <el-input v-model="inputErrorFields.proof"
                      placeholder="请输入审核不通过原因"
                      style="width:250px"
                      v-if="errorFields.proof === 5"
                      :maxlength="20"></el-input>
            <el-button type="primary"
                       icon="el-icon-delete"
                       v-if="dialogVisible.proof"
                       @click="removeErrorMessage('proof')"></el-button>
          </el-col>
          <el-col :span="24">
            <el-form-item label="联系电话:">{{form.contactto}}
              <i class="el-icon-circle-plus"
                 @click="showErrorMessage('contactto')"></i>
            </el-form-item>
            <el-select v-model="errorFields.contactto"
                       placeholder="请选择"
                       v-if="dialogVisible.contactto"
                       @change="onSelectErrorMessage('contactto')">
              <el-option v-for="item in options.errorMessage"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
            <el-input v-model="inputErrorFields.contactto"
                      placeholder="请输入审核不通过原因"
                      style="width:250px"
                      v-if="errorFields.contactto === 5"
                      :maxlength="20"></el-input>
            <el-button type="primary"
                       icon="el-icon-delete"
                       v-if="dialogVisible.contactto"
                       @click="removeErrorMessage('contactto')"></el-button>
          </el-col>
          <el-col :span="24">
            <el-form-item label="发布单位:">
              {{form.employer_name}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row style="text-align:center">
        <Br/>
        <router-link :to="'/position/pending-audit-update/'+id+'?creator='+creator">
          <el-button>修改职位信息</el-button>
        </router-link>
        <el-button @click="passDialogVisible = true"
                   :disabled="!checkPassVisible">审核通过
        </el-button>
        <el-button @click="failDialogVisible = true"
                   :disabled="checkPassVisible">审核不通过
        </el-button>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <router-link :to="{ path: '/position/pending-audit-table'}">
          <el-button>返回</el-button>
        </router-link>
      </el-row>
    </layout-panel>
    <el-dialog :visible.sync="passDialogVisible"
               width="30%"
               center>
      <span>审核通过后，该职位到上线时间会自动上线，请确认操作。</span>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="onPassAuditPosition()">确认</el-button>
        <el-button @click="passDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="failDialogVisible"
               width="30%"
               center>
      <span>审核不通过后，该职位将退还给招聘方,请确认操作。</span>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="onFailAuditPosition()">确认</el-button>
        <el-button @click="failDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { searchRules } from '../position.rules.js'

export default {
  data () {
    return {
      searchRules,
      checkPassVisible: true, // true表示审核通过,false表示审核不通过
      creator: this.$route.query.creator,
      passDialogVisible: false,
      failDialogVisible: false,
      id: this.$route.params.id,
      errorFields: {
        industry_type: null,
        position_type: null,
        title: null,
        hire_number: null,
        address: null,
        employer_name: null,
        position_period: null,
        working_shifts: null,
        working_hours: null,
        gender: null,
        age_range: null,
        certificate: null,
        education: null,
        marriage: null,
        working_experience: null,
        other_requirements: null,
        salary: null,
        salary_type: null,
        commission: null,
        quarterly_bonus: null,
        insurance: null,
        overtime_pay: null,
        meal_allowance: null,
        commute_allowance: null,
        phone_allowance: null,
        welfare: null,
        settlement_type: null,
        settlement_time: null,
        proof: null,
        contactto: null,
      },
      inputErrorFields: {
        industry_type: null,
        position_type: null,
        title: null,
        hire_number: null,
        address: null,
        employer_name: null,
        position_period: null,
        working_shifts: null,
        working_hours: null,
        gender: null,
        age_range: null,
        certificate: null,
        education: null,
        marriage: null,
        working_experience: null,
        other_requirements: null,
        salary: null,
        salary_type: null,
        commission: null,
        quarterly_bonus: null,
        insurance: null,
        overtime_pay: null,
        meal_allowance: null,
        commute_allowance: null,
        phone_allowance: null,
        welfare: null,
        settlement_type: null,
        settlement_time: null,
        proof: null,
        contactto: null,
      },
      // searchRules,
      form: {
        up_date: null,
        down_date: null,
        industry_type: null,
        position_type: null,
        title: null,
        hire_number: 0,
        address: null,
        employer_name: null,
        position_period: null,
        working_shifts: null,
        working_hours: null,
        gender: null,
        age_range: null,
        certificate: null,
        education: null,
        marriage: null,
        working_experience: null,
        other_requirements: null,
        salary: null,
        salary_type: null,
        commission: null,
        quarterly_bonus: null,
        insurance: null,
        overtime_pay: null,
        meal_allowance: null,
        commute_allowance: null,
        phone_allowance: null,
        welfare: null,
        settlement_type: null,
        settlement_time: null,
        status: null,
        province_name: null,
        city_name: null,
        area_name: null,
        email: null,
        proof: [],
        contactto: null,
      },
      checkForm: {
        userid: null,
        realname: null,
        level: null,
        currentstatus: null,
        current_location: [],
        cellphone: null,
        registertime: null,
        balance: 0,
        frozenbalance: 0,
        totalwithdraw: 0,
        frozenpoints: 0,
        points: 0,
        spendpoints: 0,
      },
      options: {
        industry_type: [],
        salary: [],
        position_type: [],
        salary_type: [],
        gender: [],
        settlement_type: [],
        settlement_time: [],
        education: [],
        marriage: [],
        insurance: [],
        level: [],
        currentstatus: [],
        errorMessage: [
          {value: 1, label: '选项选择有误'},
          {value: 2, label: '未按要求填写内容'},
          {value: 3, label: '内容填写有误'},
          {value: 4, label: '请详细描述信息内容'},
          {value: 5, label: '其他（手动填写）'},
        ],
      },
      dialogVisible: {
        industry_type: false,
        position_type: false,
        title: false,
        hire_number: false,
        address: false,
        employer_name: false,
        position_period: false,
        working_shifts: false,
        working_hours: false,
        gender: false,
        age_range: false,
        certificate: false,
        education: false,
        marriage: false,
        working_experience: false,
        other_requirements: false,
        salary: false,
        salary_type: false,
        commission: false,
        quarterly_bonus: false,
        insurance: false,
        overtime_pay: false,
        meal_allowance: false,
        commute_allowance: false,
        phone_allowance: false,
        welfare: false,
        settlement_type: false,
        settlement_time: false,
        proof: false,
        contactto: false,
      },
    }
  },
  computed: Vuex.mapState({}),
  created () {
    request.all.page([
      request('getPostionForm', this.id),
      request('editPostionOptions'),
      request('getUserDetail', this.creator),
      request('getUserRelatedOptions'),
      request('getUserCredit', this.creator),
      request('getUserPoints', this.creator),
    ]).then(([postionForm, postionOptions, userDetail, relatedOptions, userCredit, userPoints]) => {
      (({data}) => {
        filter.setLoop(this.form, data)
      })(postionForm)

      ;(({data}) => {
        filter.setLoop(this.options, data)
      })(postionOptions)

      ;(({data}) => {
        filter.setLoop(this.checkForm, data)
      })(userDetail)

      ;(({data}) => {
        filter.setLoop(this.options, data)
      })(relatedOptions)

      ;(({data}) => {
        filter.setLoop(this.checkForm, data)
      })(userCredit)

      ;(({data}) => {
        filter.setLoop(this.checkForm, data)
      })(userPoints)
    })
  },
  methods: {
    ...Vuex.mapActions(['getPostionForm', 'editPostionOptions', 'passAuditPosition', 'failAuditPosition',
      'getUserDetail', 'getUserRelatedOptions', 'getUserCredit', 'getUserPoints']),
    onPassAuditPosition () {
      return request.common('passAuditPosition', this.id).then((data) => {
        this.passDialogVisible = false
        this.$router.push({path: '/position/pending-audit-table'})
      })
    },
    onFailAuditPosition () {
      let errorFields = []
      for (const key in this.errorFields) {
        console.log(this.errorFields)
        if (this.errorFields[key] !== null) {
          if (this.errorFields[key] === 5) {
            errorFields.push({field: key, message: this.inputErrorFields[key]})
          } else {
            for (let i = 0; i < this.options.errorMessage.length; i++) {
              if (this.errorFields[key] === this.options.errorMessage[i].value) {
                errorFields.push({field: key, message: this.options.errorMessage[i].label})
              }
            }
          }
        }
      }
      let detail = {
        position_id: this.id,
        errorFields: errorFields,
      }
      return request.common('failAuditPosition', detail).then((data) => {
        this.failDialogVisible = false
        this.$router.push({path: '/position/pending-audit-table'})
      })
    },
    showErrorMessage (name) {
      this.dialogVisible[name] = true
    },
    onSelectErrorMessage (name) {
      if (this.checkPassVisible === true) {
        this.checkPassVisible = false
      }
    },
    removeErrorMessage (name) {
      this.dialogVisible[name] = false
      this.errorFields[name] = null
      for (const value in this.dialogVisible) {
        if (this.dialogVisible[value] === true) {
          return false
        }
      }
      this.checkPassVisible = true
    },
    onClearErrorMessage (name) {
      this.errorFields[name] = null
      for (const value in this.errorFields) {
        if (this.errorFields[value] !== null) {
          return false
        }
      }
      this.checkPassVisible = true
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/position/pages/PositionCheckDetail.vue